import { createApp } from 'vue'
import { setupI18n, loadLocaleMessages } from './config/i18n.js'
import store from './store'
import router from './router'
import clickOutsidePlugin from './plugins/click-outside.js'
import eventBus from './plugins/event-bus.js'
import globalMixin from './mixins/global.js'

import './theme/style.scss'
import App from './App.vue'

const app = createApp(App)

app.config.globalProperties.$bus = eventBus

app.use(store)
app.use(router)
app.use(clickOutsidePlugin)

const i18n = setupI18n()
loadLocaleMessages(i18n, 'en')
app.use(i18n)

app.mixin(globalMixin)

app.mount('#app')
